// ── Clientes ──────────────────────────────────────────────────
import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, Pagination, formatDate } from '../../components/shared';
import api from '../../services/api';
import toast from 'react-hot-toast';

function ClienteModal({ clienteId, onClose }) {
  const [dados, setDados]   = useState(null);
  const [loading, setLoad]  = useState(true);

  useEffect(() => {
    api.get(`/clientes/${clienteId}`)
      .then(r => setDados(r.data))
      .catch(() => toast.error('Erro ao carregar cliente'))
      .finally(() => setLoad(false));
  }, [clienteId]);

  const campo = (label, valor) => valor ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <span style={{ fontSize: '.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.05em' }}>{label}</span>
      <span style={{ fontSize: '.9rem', color: 'var(--text)' }}>{valor}</span>
    </div>
  ) : null;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
      zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 16, width: '100%', maxWidth: 520,
        maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,.2)',
      }}>
        {/* Header */}
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2 style={{ margin: 0, fontSize: '1rem', fontWeight: 800 }}>Dados do Cliente</h2>
          <button onClick={onClose} style={{
            background: '#f5f5f5', border: 'none', borderRadius: 8, width: 32, height: 32,
            cursor: 'pointer', fontSize: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>✕</button>
        </div>

        {/* Body */}
        <div style={{ overflowY: 'auto', padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 20 }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
              <div className="spinner" />
            </div>
          ) : dados ? (
            <>
              {/* Dados pessoais */}
              <div>
                <p style={{ margin: '0 0 12px', fontSize: '.75rem', fontWeight: 800, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '.06em' }}>
                  Dados Pessoais
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                  {campo('Nome', dados.nome)}
                  {campo('Status', dados.status)}
                  {campo('E-mail', dados.email)}
                  {campo('Telefone', dados.telefone)}
                  {campo('CPF', dados.cpf)}
                  {campo('Cadastrado em', formatDate(dados.criado_em))}
                </div>
              </div>

              {/* Endereço principal (da tabela clientes) */}
              {(dados.endereco || dados.cidade) && (
                <div>
                  <p style={{ margin: '0 0 12px', fontSize: '.75rem', fontWeight: 800, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '.06em' }}>
                    Endereço Principal
                  </p>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                    {campo('Logradouro', dados.endereco)}
                    {campo('Número', dados.numero)}
                    {campo('Complemento', dados.complemento)}
                    {campo('Bairro', dados.bairro)}
                    {campo('Cidade', dados.cidade && `${dados.cidade}${dados.estado ? '/' + dados.estado : ''}`)}
                    {campo('CEP', dados.cep)}
                  </div>
                </div>
              )}

              {/* Endereços salvos */}
              {dados.enderecos?.length > 0 && (
                <div>
                  <p style={{ margin: '0 0 12px', fontSize: '.75rem', fontWeight: 800, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '.06em' }}>
                    Endereços Salvos ({dados.enderecos.length})
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {dados.enderecos.map(e => (
                      <div key={e.id} style={{
                        background: '#f8f7f4', borderRadius: 10, padding: '12px 14px',
                        borderLeft: `3px solid ${e.padrao ? 'var(--primary)' : '#ddd'}`,
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                          <span style={{ fontWeight: 700, fontSize: '.85rem' }}>{e.apelido}</span>
                          {e.padrao && <span style={{ fontSize: '.7rem', background: 'var(--primary)', color: '#fff', borderRadius: 6, padding: '1px 7px', fontWeight: 700 }}>Padrão</span>}
                        </div>
                        <span style={{ fontSize: '.82rem', color: '#555', lineHeight: 1.5 }}>
                          {[e.endereco, e.numero, e.complemento, e.bairro, e.cidade && `${e.cidade}/${e.estado}`, e.cep].filter(Boolean).join(', ')}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {dados.enderecos?.length === 0 && !dados.endereco && (
                <p style={{ color: 'var(--text-muted)', fontSize: '.85rem', textAlign: 'center', margin: 0 }}>
                  Nenhum endereço cadastrado
                </p>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export function AdminClientes() {
  const [clientes, setClientes]       = useState([]);
  const [total, setTotal]             = useState(0);
  const [page, setPage]               = useState(1);
  const [busca, setBusca]             = useState('');
  const [loading, setLoading]         = useState(true);
  const [clienteSelecionado, setSel]  = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get('/clientes', { params: { page, limit: 15, busca } })
      .then(r => { setClientes(r.data.dados); setTotal(r.data.total); })
      .catch(() => toast.error('Erro ao carregar'))
      .finally(() => setLoading(false));
  }, [page, busca]);

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="admin_empresa" />
      <div className="main-content">
        <div className="topbar"><h1>Clientes</h1></div>
        <div className="page-content">
          <div className="table-card">
            <div className="table-header">
              <div className="search-input">
                <Icon name="search" />
                <input className="form-control" placeholder="Buscar cliente..." value={busca}
                  onChange={e => { setBusca(e.target.value); setPage(1); }}
                  style={{ width: '240px', paddingLeft: '34px' }} />
              </div>
              <span style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>{total} cliente(s)</span>
            </div>
            {loading ? <div className="loading-center"><div className="spinner" /></div> : (
              <div className="table-wrapper">
                <table>
                  <thead><tr><th>Nome</th><th>Email</th><th>Telefone</th><th>Pedidos</th><th>Último pedido</th><th>Status</th></tr></thead>
                  <tbody>
                    {clientes.map(c => (
                      <tr key={c.id} onClick={() => setSel(c.id)}
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                        onMouseLeave={e => e.currentTarget.style.background = ''}>
                        <td style={{ fontWeight: 600 }}>{c.nome}</td>
                        <td style={{ fontSize: '.85rem' }}>{c.email}</td>
                        <td>{c.telefone}</td>
                        <td style={{ fontWeight: 700, color: c.total_pedidos > 0 ? 'var(--primary)' : 'var(--text-muted)' }}>
                          {c.total_pedidos || 0}
                        </td>
                        <td style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>
                          {c.ultimo_pedido ? formatDate(c.ultimo_pedido) : '—'}
                        </td>
                        <td><span className={`badge ${c.status === 'ativo' ? 'badge-success' : 'badge-danger'}`}>{c.status}</span></td>
                      </tr>
                    ))}
                    {!clientes.length && <tr><td colSpan={6}><div className="empty-state"><Icon name="users" /><h3>Nenhum cliente</h3></div></td></tr>}
                  </tbody>
                </table>
              </div>
            )}
            <div className="table-footer">
              <span>Mostrando {clientes.length} de {total}</span>
              <Pagination page={page} total={total} limit={15} onChange={setPage} />
            </div>
          </div>
        </div>
      </div>

      {clienteSelecionado && (
        <ClienteModal clienteId={clienteSelecionado} onClose={() => setSel(null)} />
      )}
    </div>
  );
}

// ── Relatórios ─────────────────────────────────────────────────
export function AdminRelatorios() {
  const [data, setData]     = useState(null);
  const [loading, setLoad]  = useState(true);

  useEffect(() => {
    api.get('/dashboard')
      .then(r => setData(r.data))
      .catch(() => toast.error('Erro'))
      .finally(() => setLoad(false));
  }, []);

  const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="admin_empresa" />
      <div className="main-content">
        <div className="topbar"><h1>Relatórios</h1></div>
        <div className="page-content">
          {loading ? <div className="loading-center"><div className="spinner" /></div> : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

              {/* Por Status */}
              <div className="table-card">
                <div className="table-header"><h3>Pedidos por Status</h3></div>
                <div className="table-wrapper">
                  <table>
                    <thead><tr><th>Status</th><th>Quantidade</th></tr></thead>
                    <tbody>
                      {data?.por_status?.map(s => (
                        <tr key={s.status}>
                          <td style={{ textTransform: 'capitalize' }}>{s.status.replace('_', ' ')}</td>
                          <td style={{ fontWeight: 700 }}>{s.count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Produtos mais vendidos */}
              <div className="table-card">
                <div className="table-header"><h3>Produtos Mais Vendidos</h3></div>
                <div className="table-wrapper">
                  <table>
                    <thead><tr><th>Produto</th><th>Quantidade</th><th>Faturamento</th></tr></thead>
                    <tbody>
                      {data?.mais_vendidos?.length
                        ? data.mais_vendidos.map((p, i) => (
                          <tr key={i}>
                            <td>{p.descricao_produto}</td>
                            <td style={{ fontWeight: 700 }}>{parseFloat(p.qtd).toFixed(0)}</td>
                            <td style={{ color: 'var(--success)', fontWeight: 700 }}>{fmt(p.total)}</td>
                          </tr>
                        ))
                        : <tr><td colSpan={3}><div className="empty-state" style={{ padding: '30px' }}><h3>Sem dados</h3></div></td></tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Faturamento 7 dias */}
              <div className="table-card">
                <div className="table-header"><h3>Faturamento — Últimos 7 dias</h3></div>
                <div className="table-wrapper">
                  <table>
                    <thead><tr><th>Data</th><th>Pedidos</th><th>Total</th></tr></thead>
                    <tbody>
                      {data?.faturamento_7d?.length
                        ? data.faturamento_7d.map((d, i) => (
                          <tr key={i}>
                            <td>{new Date(d.dia).toLocaleDateString('pt-BR')}</td>
                            <td>{d.pedidos}</td>
                            <td style={{ color: 'var(--success)', fontWeight: 700 }}>{fmt(d.total)}</td>
                          </tr>
                        ))
                        : <tr><td colSpan={3}><div className="empty-state" style={{ padding: '30px' }}><h3>Sem dados no período</h3></div></td></tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
